import '../styles/sorbent.scss';

import Application from './application';

Application();
